import { render, staticRenderFns } from "./EducationalGroupAdd.vue?vue&type=template&id=2269a570&"
import script from "./EducationalGroupAdd.vue?vue&type=script&lang=js&"
export * from "./EducationalGroupAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports